<template>
  <div class="preservation-yg-dlr">
    <MyTitle theTitle="原告代理人" />
    <!-- <div class="my-title">
            <van-icon class="left-icon" name="arrow-left" @click="goBack"/>
            <div class="title-center">
                <h3>原告代理人</h3>
                <slot></slot>
            </div>
            <van-icon class="right-icon" name="wap-home-o" @click="goHome"/>
        </div> -->
      <van-cell-group class="fd-com-scroll">
        <van-field
          v-model="formData.ssygText"
          required
          clearable
          readonly
          label="所属原告"
          right-icon="arrow"
          placeholder="请选择申请人"
          @click="goToSsyg"
        ></van-field>
        <!--            <div  v-for="(item, index) in formData.sqrInfo" :key="index">-->
        <!--                {{item}}-->
        <!--            </div>-->
        <van-field
          readonly
          v-for="(item, index) in formData.sqrInfo"
          :key="index"
          :label="item.sqrXm"
          v-model="item.sqrLx"
        ></van-field>
        <van-field
          v-model="formData.dlrlxText"
          required
          clearable
          readonly
          label="代理人类型"
          right-icon="arrow"
          placeholder="请选择代理人类型"
          @click="showDlrlxPicker = true"
        ></van-field>
        <van-popup v-model="showDlrlxPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="codeList_103000"
            :default-index="0"
            @cancel="showDlrlxPicker = false"
            @confirm="onDlrlxConfirm"
          ></van-picker>
        </van-popup>
        <van-field
          v-model="formData.dlrxm"
          required
          clearable
          label="代理人姓名"
          placeholder="请输入代理人姓名"
        ></van-field>
        <van-field required label="性别">
          <van-radio-group
            slot="input"
            v-model="formData.xb">
            <van-radio
              v-for="item in codeList_110000"
              :name="item.keyId"
              :key="item.keyId">
              {{ item.text }}
            </van-radio>
          </van-radio-group>
        </van-field>
        <van-field
          v-model="formData.zjlxText"
          required
          clearable
          readonly
          label="证件类型"
          right-icon="arrow"
          placeholder="请选择证件类型"
          @click="showZjlxPicker = true"
        ></van-field>
        <van-popup v-model="showZjlxPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="codeList_105000"
            :default-index="0"
            @cancel="showZjlxPicker = false"
            @confirm="onZjlxConfirm"
          ></van-picker>
        </van-popup>
        <van-field
          v-model="formData.zjhm"
          required
          clearable
          label="证件号码"
          placeholder="请输入证件号码"
        ></van-field>
        <van-field
          v-model="formData.sjhm"
          required
          clearable
          label="手机号码"
          placeholder="请输入手机号码"
        ></van-field>
        <div v-if="formData.dlrlx == 1">
          <van-field
            v-if="showZyls"
            v-model="formData.zyzjhm"
            required
            clearable
            label="执业证件号码"
            placeholder="请输入执业证件号码"
          ></van-field>
          <van-field
            v-if="showZyls"
            v-model="formData.ls"
            required
            clearable
            label="代理人所在律所"
            placeholder="请输入律所名称"
          ></van-field>
        </div>
        <!-- <van-field
                        v-model="formData.gddh"
                        clearable
                        label="固定电话"
                        placeholder="请输入固定电话"
                ></van-field> -->
        <section class="fd-com-section">
          <div class="fd-com-title">
            固定电话
          </div>
          <van-field
            v-model="formData.cGh1"
            label="区号"
            placeholder="请输入区号"
          ></van-field>
          <van-field
            v-model="formData.cGh2"
            label="电话号码"
            placeholder="请输入电话号码"
          ></van-field>
          <van-field
            v-model="formData.cGh3"
            label="分机号"
            placeholder="请输入分机号"
          ></van-field>
        </section>
      </van-cell-group>
      <div class="fd-com-btn-container">
        <van-button
          v-if="ygdlrId"
          type="info"
          round
          plain
          :disabled="!saveBtnClickable"
          @click="addYgdlrAndReturn"
        >
          确认
        </van-button>
        <van-button
          v-if="!ygdlrId"
          type="info"
          round
          plain
          :disabled="!saveBtnClickable"
          @click="addYgdlrAndReturn"
        >
          添加
        </van-button>
        <van-button
          v-if="!ygdlrId"
          type="info"
          round
          :disabled="!saveBtnClickable"
          @click="addYgdlrAndContinue"
        >
          确认并继续添加
        </van-button>
      </div>
  </div>
</template>

<script>
import MyTitle from "../../../components/common/myTitle";
import { typeRylx, typeDlrlx, typeSfzjlx } from "../../../filters/index";
import validate from "@/utils/validator/validator";
import {
  ssygRule,
  dlrlxRule,
  XmRule,
  zjlxRule,
  ZjhmRule,
  PhoneRule,
  GddhRule,
  ZyzjhmRule,
  LsRule,
  QhRule, // 区号
  DhhmRule, //电话号码
  FjhRule, // 分机号
} from "@/utils/validator/rules";
import { mapGetters } from "vuex";
export default {
  components: {
    MyTitle,
  },
  data() {
    return {
      bqid: "",
      ygdlrId: "",
      ygdlrIds: "",
      formData: {
        ssyg: "", // 所属原告
        sqrInfo: [], // 申请人信息(id, 类型, 名字)
        ssygText: "", // 所属原告文字描述
        dlrlx: 1, // 代理人类型
        dlrlxText: "执业律师", // 代理人类型文字描述
        dlrxm: "", // 代理人姓名
        zjlx: 1, // 证件类型
        zjlxText: "居民身份证", // 证件类型描述
        zjhm: "", // 证件号码
        sjhm: "", // 手机号码
        zyzjhm: "", // 执业证件号码
        ls: "", // 律所
        gddh: "", // 固定电话
        xb: "1", // 性别
        cGh1: "",
        cGh2: "",
        cGh3: "",
      },
      postData: {
        cBqSqrids: [], // 代理人对应的申请人ids
        cDlrlx: "", // 代理人类型
        cDlrxm: "", // 代理人姓名
        cDlrzjlx: "", // 代理人证件类型
        cDlrzjh: "", // 代理人证件号码
        cDlrzjhm: "", // 代理人执业证件号码
        cDlrszls: "", // 代理人所在律所
        cGddh: "", // 固定电话
        cPhone: "", // 手机号码
      },
      showZjlxPicker: false,
      showDlrlxPicker: false,
      showZyls: true,
      saveBtnClickable: true, // 保存按钮是否可以点击
    };
  },
  computed: {
    ...mapGetters(["codeList_103000", "codeList_105000", "codeList_110000"]),
  },
  methods: {

    /**
     * @function
     * @description 对接在线服务网新增——处理数据，原来写在请求里的，提出来，不然要写两遍（不知道为什么原来这么多字段弄成不一样，不易维护）
     * @param {Object} data 表单对象数据
     * @return {undefined} 无返回值
     */
    handleData(data) {
        this.formData.dlrlx = data.cDlrlx;
        this.formData.dlrlxText = typeDlrlx(data.cDlrlx);
        this.formData.dlrxm = data.cDlrxm;
        this.formData.zjlx = data.cDlrzjlx;
        this.formData.zjlxText = typeSfzjlx(data.cDlrzjlx);
        this.formData.zjhm = data.cDlrzjh;
        this.formData.zyzjhm = data.cDlrzjhm;
        this.formData.ls = data.cDlrszls;
        this.formData.gddh = data.cGddh;
        let cGh = this.formData.gddh.split("-");
        this.formData.cGh1 = cGh[0];
        this.formData.cGh2 = cGh[1];
        this.formData.cGh3 = cGh[2];
        this.formData.sjhm = data.cPhone;
        this.formData.xb = data.cDlrxb;
    },

    // goBack() {
    //      this.$router.push('/preservationInfo')
    // },
    // goHome() {
    //     this.$router.push('/home/index')
    // },
    onZjlxConfirm: function (value) {
      this.showZjlxPicker = false;
      this.formData.zjlxText = value.text;
      this.formData.zjlx = value.keyId;
    },
    onDlrlxConfirm: function (value) {
      // 重新选择代理人类型,并且是编辑状态,先清除数据
      let ygdlrId = JSON.parse(sessionStorage.getItem("ygdlrId"));
      if (ygdlrId && ygdlrId != "undefined" && ygdlrId != "") {
        // this.clearData();
        sessionStorage.removeItem("ygdlrIds");
        this.formData.dlrlx = "";
        this.formData.dlrlxText = "";
        this.formData.dlrxm = "";
        this.formData.zjlx = "";
        this.formData.zjlxText = "";
        this.formData.zjhm = "";
        this.formData.sjhm = "";
        this.formData.zyzjhm = "";
        this.formData.ls = "";
        this.formData.gddh = "";
      }
      // 从后端拉取数据
      this.initUpdateData(JSON.parse(sessionStorage.getItem("ygdlrId")));
      if (value.keyId == 1) {
        // 执业律师
        this.showZyls = true;
      } else {
        // 其他代理人类型
        this.showZyls = false;
        // sessionStorage.removeItem("ygdlrId")
      }
      this.showDlrlxPicker = false;
      this.formData.dlrlxText = value.text;
      this.formData.dlrlx = value.keyId;
      window.sessionStorage.setItem("Dlrlx", value.keyId);
      this.formData.zjlx = 1;
      this.formData.zjlxText = "居民身份证";
      // sessionStorage.removeItem("ygdlrId")
    },
    goToSsyg: function () {
      sessionStorage.setItem(
        "checkedSqr",
        JSON.stringify(this.formData.sqrInfo)
      );
      this.$router.push("/getBqSsygList");
    },
    addYGDLR: function () {
      this.saveBtnClickable = false;
      let ygdlrId = JSON.parse(sessionStorage.getItem("ygdlrId"));
      let ygdlrIds = JSON.parse(sessionStorage.getItem("ygdlrIds"));
      if (ygdlrId && ygdlrId != "undefined" && ygdlrId != "") {
        // 更新操作
        this.postData.cBqId = this.bqid;
        this.postData.cBqDlrid = ygdlrId;
        this.postData.nValid = 1;
      }
      sessionStorage.removeItem("bqSqrInfo");
      for (var sqr of this.formData.sqrInfo) {
        this.postData.cBqSqrids.push(sqr.sqrId);
      }
      this.postData.cDlrlx = this.formData.dlrlx;
      this.postData.cDlrxm = this.formData.dlrxm;
      this.postData.cDlrzjlx = this.formData.zjlx;
      this.postData.cDlrzjh = this.formData.zjhm;
      if (this.formData.dlrlx == 1) {
        this.postData.cDlrzjhm = this.formData.zyzjhm;
        this.postData.cDlrszls = this.formData.ls;
      }
      let ghList = [];
      for (let i = 1; i < 4; i++) {
        if (this.formData[`cGh${i}`]) {
          ghList.push(this.formData[`cGh${i}`]);
        }
      }
      this.postData.cGddh = ghList.join("-");

      this.postData.cPhone = this.formData.sjhm;
      this.postData.cDlrxb = this.formData.xb;
      return this.$axios
        .post("ssbq/api/xcx/dlr?bqid=" + this.bqid, this.postData)
        .then((res) => {
          if (res.code == 204) {
            this.$notify({ type: "success", message: "操作成功" });
            sessionStorage.setItem("bqSqrInfo", JSON.stringify([]));
          } else {
            this.$notify(res.message);
          }
        })
        .catch(() => {});
    },
    addYgdlrAndReturn: function () {
      const validated = this.validateFormData();
      validated.then(() => {
        this.addYGDLR().then(() => {
          this.$router.push({
            path: "/preservationInfo",
          });
        });
      });
    },
    addYgdlrAndContinue: function () {
      this.validateFormData().then(() => {
        this.addYGDLR().then(() => {
          // this.clearData();
          setTimeout(() => {
            window.location.reload();
          }, 500);
        });
      });
    },
    initUpdateData: function (ygdlrId, firstVisit) {
      return new Promise((resolve) => {
        if (!ygdlrId || ygdlrId == "undefined" || ygdlrId == "") {
          resolve();
          return;
        }
        this.$axios
          .get("ssbq/api/ygdlr?id=" + ygdlrId)
          .then((res) => {
            let data = res.data;
            if (firstVisit || this.formData.dlrlx == data.cDlrlx) {
                this.handleData(data);

              let currentBqid = JSON.parse(
                sessionStorage.getItem("currentBqid")
              );
              this.bqid = currentBqid;
              // 获取当前原告代理人所属申请人信息
              this.$axios
                .get("ssbq/api/sqrs?bqid=" + currentBqid)
                .then((res) => {
                  let sqrList = res.data;
                  // 原告代理人所属申请人, 多个id传递数组参数cBqSqrids, 但是返回的是cBqSqrid字段,
                  // 多个值为一个字符串, 逗号分割形式
                  let cBqSqrids = data.cBqSqrid.split(",");
                  this.formData.sqrInfo = new Array();
                  for (let item of sqrList) {
                    for (let id of cBqSqrids) {
                      if (id == item.cId) {
                        let sqr = {
                          sqrId: item.cId,
                          sqrLx: typeRylx(item.cSqrlx),
                        };
                        if (item.cSqrlx == 1) {
                          // 自然人
                          sqr.sqrXm = item.cSqrxm;
                        } else {
                          // 原告代理人
                          sqr.sqrXm = item.cQymc;
                        }
                        this.formData.sqrInfo.push(sqr);
                      }
                    }
                  }
                  resolve();
                })
                .catch(function (error) {
                  console.log(error);
                });
            }
          })
          .catch(() => {});
      });
    },
    clearData: function () {
      let formData = this.formData;
      for (let key in formData) {
        formData[key] = "";
      }
    },
    validateFormData: function () {
      let descriptor = {
        sqrInfo: ssygRule,
        dlrlx: dlrlxRule,
        dlrxm: new XmRule(true),
        zjlx: zjlxRule,
        zjhm: new ZjhmRule(this.formData.zjlx, true),
        sjhm: new PhoneRule(true),
        // gddh: new GddhRule(false)
        cGh1: new QhRule(false),
        cGh2: new DhhmRule(false),
        cGh3: new FjhRule(false),
      };
      if (this.formData.dlrlx == 1) {
        // 执业律师校验规则
        descriptor.zyzjhm = new ZyzjhmRule(true);
        descriptor.ls = new LsRule(true);
      }
      let validated = validate(descriptor, this.formData);
      return validated;
    },
    initCodeType() {
      /* 代理人类型 */
      this.$store.dispatch("GetCodeType", 103000);
      /* 证件类型 */
      this.$store.dispatch("GetCodeType", 105000);
      /* 性别 */
      this.$store.dispatch("GetCodeType", 110000);
    },
  },
  created() {
    this.initCodeType();
    let ygdlrId = JSON.parse(sessionStorage.getItem("ygdlrId"));
    let ygdlrIds = JSON.parse(sessionStorage.getItem("ygdlrIds"));
    this.ygdlrIds = ygdlrIds;
    this.ygdlrId = ygdlrId;
    // 对接在线服务新增——回显选择添加的诉讼案件相关人员信息
    if (sessionStorage.getItem('addPersonInfo')) {
        this.handleData(JSON.parse(sessionStorage.getItem('addPersonInfo')));
    }
    this.initUpdateData(ygdlrId, true).then(() => {
      let sqrs = JSON.parse(sessionStorage.getItem("bqSqrInfo"));
      if (null != sqrs && sqrs.length > 0) {
        this.formData.sqrInfo = sqrs;
        this.formData.sqrInfo.forEach((item) => {
          item.sqrLx = typeRylx(item.sqrLx);
        });
      }
    });
    let currentBqid = JSON.parse(sessionStorage.getItem("currentBqid"));
    this.bqid = currentBqid;
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name == "getBqSsygList") {
        let Dlrlx = window.sessionStorage.getItem("Dlrlx");
        vm.formData.dlrlx = Dlrlx;
        vm.formData.dlrlxText = typeDlrlx(Dlrlx);
      }
      if (from.name == "preservationInfo") {
        window.sessionStorage.setItem("Dlrlx", "1");
        // window.sessionStorage.removeItem('Dlrlx')
      }
    });
  },
};
</script>

<style lang="less" scoped>
.my-title {
  box-sizing: border-box;
  padding: 12px 10px 0 10px;
  height: 44px;
  display: flex;
  justify-content: space-between;
  background: #f6f6f6;
  position: relative;

  .left-icon,
  .right-icon {
    line-height: 44px/2;
    font-size: 24px;
  }

  .title-center {
    display: flex;
    justify-content: center;

    > div {
      /*position: absolute;*/
      /*right: 28%;*/
      font-size: 18px;
      line-height: 44px/2;
    }
  }

  h3 {
    display: inline-block;
    margin: 0 auto;
    line-height: 20px;
    font-size: 18px;
    font-weight: normal;
    white-space: nowrap;
    line-height: 44px/2;
    padding-right: 8px;
  }
}
</style>
